<template>
  <div class="panel-list-page">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="navProducts"/>
          </span>
          <div>
            <h1 class="pl-card__title">لیست برندها</h1>
            <p class="pl-card__sub">مدیریت برندهای محصولات</p>
          </div>
        </div>
        <div class="pl-toolbar">
          <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
            <CIcon name="iconPlus"/>
            <span>افزودن برند جدید</span>
          </button>
        </div>
      </div>

      <div class="pl-card__body">
        <CDataTableFixed
          class="pl-table"
          :items="items"
          :fields="fields"
          :items-per-page="20"
          hover
          sorter
          pagination
          :noItemsView="{ noItems: 'برندی یافت نشد' }"
        >
          <template #no-items-view>
            <div class="pl-empty">
              <span class="pl-empty__icon" aria-hidden="true">
                <CIcon name="navProducts"/>
              </span>
              <p class="pl-empty__title">برندی یافت نشد</p>
              <p class="pl-empty__sub">برای شروع، یک برند جدید اضافه کنید.</p>
              <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
                <CIcon name="iconPlus"/>
                <span>افزودن برند جدید</span>
              </button>
            </div>
          </template>

          <template #row="{ item }">
            <td>
              <span class="pl-muted">{{ item.row_id + 1 }}</span>
            </td>
          </template>

          <template #image="{ item }">
            <td>
              <div class="pl-thumb" v-if="item.image">
                <CImg width="44px" height="44px" :src="item.image"/>
              </div>
              <span v-else class="pl-muted">—</span>
            </td>
          </template>

          <template #title="{ item }">
            <td>
              <span class="pl-name">{{ item.title.title }}</span>
            </td>
          </template>

          <template #seo_title="{ item }">
            <td>
              <span class="pl-muted">{{ item.title.seo_title }}</span>
            </td>
          </template>

          <template #operation="{ item }">
            <td class="pl-ops-cell">
              <div class="pl-ops">
                <button type="button" class="pl-icon-btn pl-icon-btn--warn" title="ویرایش" @click="openEditModal(item)">
                  <CIcon name="iconEdit"/>
                </button>
                <button type="button" class="pl-icon-btn pl-icon-btn--danger" title="حذف" @click="delete_item_dialog(item)">
                  <CIcon name="iconTrash"/>
                </button>
              </div>
            </td>
          </template>
        </CDataTableFixed>
      </div>
    </div>

    <CModal
      :show.sync="form_modal"
      :centered="true"
      size="lg"
      :title="status_form == 0 ? 'افزودن برند جدید' : 'ویرایش برند'"
      @update:show="onFormModalToggle"
    >
      <div class="pl-form">
        <CRow>
          <CCol col="12" md="6">
            <CInput
              v-model="name"
              class="required"
              label="نام برند"
              placeholder="نام برند"
            />
          </CCol>
          <CCol col="12">
            <CTextarea
              v-model="description"
              label="توضیحات برند"
              placeholder="توضیحات"
              rows="4"
            />
          </CCol>
          <CCol col="12">
            <ImageSelector
              label="تصویر"
              :media_id.sync="file"
              :multiple="false"
              default_archive="product_brand"
              :preview-image="previewImage"
            />
          </CCol>
          <CCol col="12" class="mt-3">
            <SeoBox ref="seo"
                    entity-type="brand"
                    :entity-id="status_form"
                    :name="name"
                    :slug="seoSlug(name)"
                    url-prefix="/shop/brand/"
                    :content-html="seoHtml(description)"
                    :title.sync="seo_title"
                    :default-image="previewImage || ''"
                    default-schema="CollectionPage"
            />
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <button type="button" class="pl-btn pl-btn--ghost" @click="closeFormModal()">انصراف</button>
        <button type="button" class="pl-btn pl-btn--primary" @click="login()">
          <CIcon name="iconCheck"/>
          <span>{{ status_form == 0 ? 'ثبت برند' : 'ذخیره تغییرات' }}</span>
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "@/api/http";
import {bus} from '../../main';


export default {
  name: 'Login',
  data() {
    return {
      form_modal: false,
      confirm_delete_name:new Date().getTime()+"_"+this.$vnode.tag,
      name: '',
      file: [],
      seo_title:'',
      color: '',
      previewImage: null,
      description: '',
      items: [],
      fields: [
        {key: 'row', label: '#', _style: 'width:7%'},
        {key: 'image', label: 'تصویر', _style: 'width:10%'},
        {key: 'title', label: 'عنوان', _style: 'width:20%'},
        {key: 'seo_title', label: 'سئو عنوان', _style: 'width:20%'},
        {key: 'operation', label: 'عملیات', _style: 'width:10%'},
      ],

      status_form: 0,

    }
  }, mounted() {
    this.get_categories();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_categories();
    }
  },
  methods: {
    seoSlug(s) {
      return String(s || '').normalize('NFC').toLowerCase().trim().replace(/[\u200c\s_]+/g, '-').replace(/[^\p{L}\p{N}-]+/gu, '').replace(/-+/g, '-').replace(/^-|-$/g, '')
    },
    seoHtml(t) {
      return String(t || '').split(/\n+/).map((p) => '<p>' + p.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</p>').join('')
    },

    openCreateModal() {
      this.cancel_form();
      this.form_modal = true;
    },
    openEditModal(item) {
      this.editDetails(item);
      this.form_modal = true;
    },
    closeFormModal() {
      this.form_modal = false;
      this.cancel_form();
    },
    onFormModalToggle(show) {
      if (!show) {
        this.cancel_form();
      }
    },
    cancel_form() {
      this.name = '';
      this.seo_title = '';
      this.description = '';
      this.previewImage = null;
      this.file = [];

      this.status_form = 0;

    },
    editDetails(item) {
      this.name = item.title.title;
      this.seo_title = item.title.seo_title;
      this.description = item.title.summary;
      this.previewImage = item.image;
      this.file = [item.image_id];

      this.status_form = item.id;

    },
    get_categories() {
      var self = this;
var formData = new FormData();
      axios.post('/api/admin/product/get_brands',formData, {}).then(function (response) {

        var content_cats = response.data;

        self.items = content_cats.orders.map((item, row_id) => {
          return {...item, row_id}
        })

      })
          .catch(function (error) {

            console.log(error);
          });

    },


    login() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/product/insert_brand";
      } else {
        url = "/api/admin/product/update_brand";
        formData.append('id', this.status_form)

      }

      formData.append('image', this.file[0]);

      formData.append('name', this.name);
      formData.append('seo_title', this.seo_title);
      formData.append('description', this.description);
      axios.post(url, formData, {}).then(async (res) => {

        const seoId = self.status_form == 0 ? res.data.id : self.status_form

        if (res.data.error == 0 && seoId && self.$refs.seo) await self.$refs.seo.save(seoId)

        self.$root.modal_component.show_api_response_modals(res)

        if (res.data.error == 0) {
          url = "/api/admin/category";
          self.name = '';
          self.seo_title = '';
          self.color = '';
          self.description = '';
          self.previewImage = '';
          self.previewImage_header = '';
          self.status_form = 0;
          self.form_modal = false;
          self.get_categories();
        }

      })


          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("warning"), this.$t("deleteMessage"), [this.$t("ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/delete_brand";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_categories();


      })
          .catch(function (error) {
            console.log(error);
          });
    },
  }
}


</script>
